import { type ContentItem, type NFTContent } from './yat-page-actions';

export const ACTION_UPDATE_MANAGER_NFT_FILTERS = 'ACTION_UPDATE_MANAGER_NFT_FILTERS';
export const ACTION_SET_MANAGER_SEARCH_VALUE = 'ACTION_SET_MANAGER_SEARCH_VALUE';

type NFTManagerSortOrder = 'Asc' | 'Desc';
type NFTManagerSortField = 'activity_date' | 'floor_price' | 'gains' | 'purchase_date' | 'timescore';

export interface NFTManagerFilter {
    sortingOrder?: NFTManagerSortOrder;
    sortingField?: NFTManagerSortField;
    ownerAddress?: string[];
    floorPriceCurrency?: Currency;
    /** min */
    floorPriceGe?: number;
    /** max */
    floorPriceLe?: number;
    name?: string;
    collection?: string;
    spam?: boolean;
    unsupported?: boolean;
}

export type Currency = 'eth';
export type NFTItem = ContentItem<NFTContent>;

export interface NFTManagerState {
    managerSearchValue: string;
    managerFilters: NFTManagerFilter;
}

interface setNFTManagerSearchValue {
    type: typeof ACTION_SET_MANAGER_SEARCH_VALUE;
    managerSearchValue: string;
}

interface updateNFTManagerFilters {
    type: typeof ACTION_UPDATE_MANAGER_NFT_FILTERS;
    filter?: NFTManagerFilter;
    clear: boolean;
}

export type NFTManagerActions = updateNFTManagerFilters | setNFTManagerSearchValue;
